import { useEffect } from 'react';
import LandingNav from '../components/landing/LandingNav';
import LandingFooter from '../components/landing/LandingFooter';
import ContactHero from '../components/contact/ContactHero';
import ContactSection from '../components/contact/ContactSection';
import styles from './ContactPage.module.css';

// Public "Contact us" page. Reuses the marketing nav/footer and owns its own scroll
// container (global `body { overflow: hidden }` for the app shell).
export default function ContactPage() {
  useEffect(() => {
    document.getElementById('top')?.scrollTo({ top: 0 });
  }, []);

  return (
    <div id="top" className={styles.page}>
      <LandingNav />
      <main>
        <ContactHero />
        <ContactSection />
      </main>
      <LandingFooter />
    </div>
  );
}
